// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TerminalHardwareOrdersCountries: MarkdocTagRegistration = {
  tag: 'terminal-hardware-orders-countries',
  component: 'TerminalHardwareOrdersCountries',
  attributes: {
    countries: {
      type: Array,
      required: true,
      localizable: false,
      description:
        'List of country codes where Terminal hardware orders are able to be shipped',
    },
  },
};
